var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 72,
    r: 52.5,
    fill: "#F7F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 51L123 51",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 88.5L29.25 88.5",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117 56.25L121.5 56.25",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 93.75L27.75 93.75",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.25 51H131.25",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.022 48.7662L106.804 36.1212C107.003 34.713 108.125 33.6153 109.537 33.4483L116.194 32.6611L120.72 32.1258M105.022 48.7662L97.2026 90.915M105.022 48.7662L91.4935 49.8206L77.9647 50.875L64.4359 51.9294L50.9071 52.9837L39.8054 53.849C37.9319 53.995 36.608 55.7467 36.9789 57.5889L43.347 89.2265M97.2026 90.915L86.2081 90.5703L75.2135 90.2256L64.219 89.8809L53.2244 89.5362L43.347 89.2265M97.2026 90.915L96.4046 97.5722C96.2106 99.1905 94.8078 100.389 93.1791 100.329L89.6405 100.197M43.347 89.2265L44.3201 95.9431C44.5369 97.4395 45.7919 98.5673 47.3029 98.6234L51.1152 98.7652M63.957 99.2425L70.3779 99.4812L76.7987 99.7199M63.957 99.2425L57.5361 99.0039L54.3257 98.8845L51.1152 98.7652M63.957 99.2425L63.7498 104.981C63.6874 106.709 62.2363 108.059 60.5084 107.997L53.9268 107.762C52.1984 107.7 50.8475 106.249 50.9093 104.52L51.1152 98.7652M89.6405 100.197L86.43 100.078L83.2196 99.9586L76.7987 99.7199M89.6405 100.197L89.4365 105.899C89.3746 107.627 87.9234 108.978 86.195 108.916L79.6116 108.681C77.8832 108.619 76.5322 107.168 76.5941 105.439L76.7987 99.7199",
    stroke: "#838B98",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9073 57.4837L47.9175 58.1843C45.969 58.3362 44.9947 58.4121 44.3181 58.8605C43.724 59.2543 43.282 59.8391 43.0653 60.5181C42.8186 61.2915 43.0114 62.2494 43.3971 64.1654L44.048 67.3993",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.d6cd2a90f7363df651889581a233a441.svg";
export { ForwardRef as ReactComponent };